import {LogService} from '@aam/angular-logging';
import {SpecFilterExpression} from '@list-decorators/filters/SpecFilterExpression';
import {Store} from '@ngrx/store';
import {IAppStore} from '@app/store';
import {POAcsMessage, POEvent} from '@objects-module/model';
import {StoreBasedDatasource} from '@objects-module/datasource/base/StoreBasedDatasource';
import {POAbstractEventAction} from '@actions/POAbstractEventAction';
import {POAbstractEventSelectors} from '@selectors/POAbstractEventSelectors';

export class POAcsMessageDatasource extends StoreBasedDatasource<POAcsMessage> {
  constructor(public store: Store<IAppStore>, protected log: LogService) {
    super(store, POAcsMessage.type, log);

    this.data$ = this.store.select(
      POAbstractEventSelectors.pageObjects(POAcsMessage.type)
    );
    this.loading$ = this.store.select(
      POAbstractEventSelectors.isPageLoading(POAcsMessage.type)
    );
    this.totalElements$ = this.store.select(
      POAbstractEventSelectors.totalElements(POAcsMessage.type)
    );
    this.elementsOnPage$ = this.store.select(
      POAbstractEventSelectors.elementsCountOnPage(POAcsMessage.type)
    );
  }

  loadPage(
    filterExpression: SpecFilterExpression,
    sortExpression: string,
    pageIndex: number,
    pageSize: number
  ) {
    this.store.dispatch(
      POAbstractEventAction.getEvents(POAcsMessage.type)({
        page: pageIndex,
        itemsPerPage: pageSize,
        sortingExpression: sortExpression,
        searchExpression: filterExpression,
      })
    );
  }

  public deletePack(data: any[]) {
    this.log.error('POEventDataSource.deletePack is not implemented');
  }

  public deleteFromList(item: any) {
    this.log.error('POEventDataSource.deleteFromList is not implemented');
  }
}
